export enum ToastStatus {
  ERROR,
  SUCCESS,
  VERSION,
  WARNING
}
